var Form = require('component/forms/forms.custom.js');

$('.js-myreport-list').sortable({
	items: '.js-myreport-sortable',
	cancel: '.js-myreport-nosortable',
	//placeholder: "sortable-placeholder",
	cursor: 'move'
});

//Обработка события изменения checkbox "Выделить все"

$('.js-myreport-all').on('change', myReportAllChange);

function myReportAllChange() {
	if ($('.js-myreport-all').prop('checked')) {
		$('.js-myreport-item').prop('checked', true);
		$('.js-myreport-btn').removeAttr('disabled');
	} else {
		$('.js-myreport-item').prop('checked', false);
		$('.js-myreport-btn').attr('disabled', 'disabled');
	}
}

//Обработка события изменения checkbox элемента моего отчета
$('.js-myreport-item').on('change', myReportItemsChange);

function myReportItemsChange() {
	var $items = $('.js-myreport-item');
	var allChecked = true;
	$items.each(function () {
		if (!$(this).prop('checked')) {
			allChecked = false;
		};
	});
	if (allChecked) {
		$('.js-myreport-all').prop('checked', true);
	} else {
		$('.js-myreport-all').prop('checked', false);
	};
	if ($('.js-myreport-item:checked').length === 0) {
		$('.js-myreport-btn').attr('disabled', 'disabled');
	} else {
		$('.js-myreport-btn').removeAttr('disabled');
	}
}

//Обработка события нажатия на кнопу print
$('.js-myreport-print').on('click', myReportPrint);

function myReportPrint() {
	//do print...
	global.blurOnLeave(this);
}

//Обработка события нажатия на кнопу save
$('.js-myreport-save').on('click', myReportSave);

function myReportSave() {
	//do save...
	global.blurOnLeave(this);
}

//Обработка события нажатия на кнопу delete
$('.js-myreport-delete').on('click', myReportDelete);

function myReportDelete() {
	//do delete...
	global.blurOnLeave(this);
}

var myReportForm = new Form('div.MY_REPORT');

//Обработка события нажатия на кнопу send
$('.js-myreport-send').on('click', myReportSend);

function myReportSend() {
	//do send to email...
	myReportForm.openForm();
}

$('.js-myreport-all').prop('checked', true);
myReportAllChange();



/** WEBPACK FOOTER **
 ** ./frontend/components/my-report/my-report.custom.js
 **/